export const ThirdStep = () => {
 

    return (
        <div className="h1 d-flex justify-content-center align-items-center" style={{ height: '500px'}}>
            You Are All Set!
        </div>
    )
}